export default {"src":"/pro/_next/static/media/apt.ccfa6198.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};